import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigError: string | null =
  !supabaseUrl || !supabaseAnonKey
    ? 'Variables Supabase manquantes : définissez VITE_SUPABASE_URL et VITE_SUPABASE_ANON_KEY dans l\'environnement de build (host de déploiement) ou dans un fichier .env.local pour le dev, puis relancez le build.'
    : null;

if (supabaseConfigError) {
  console.error('[Supabase config]', supabaseConfigError);
}

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder'
);

export type Database = {
  public: {
    Tables: {
      forecasts: {
        Row: {
          id: string;
          user_id: string;
          name: string;
          state: Record<string, unknown>;
          created_at: string;
          updated_at: string;
        };
        Insert: {
          id?: string;
          user_id: string;
          name?: string;
          state: Record<string, unknown>;
        };
        Update: {
          name?: string;
          state?: Record<string, unknown>;
          updated_at?: string;
        };
      };
    };
  };
};
